import { useTranslation } from 'react-i18next';
import { Table, Pagination } from '@treezor/design-system';
import { useLocation } from 'react-router';

import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

import { AllWalletsFilters } from '@/features/wallets/components/AllWallets/AllWAlletssFilters';
import { useAllWalletsTableData } from '@/features/wallets/hooks/AllWallets/useAllWalletsTableData';

import { ItemsPerPage } from '@/ui-kit/table-filters/ItemsPerPageFilter';

export function AllWalletsTable() {
  const { t } = useTranslation();

  const state = useLocation().state || undefined;

  const {
    pagination,
    error,
    headers,
    rows,
    onPageChange,
    onSort,
    onPerPage,
    perPage,
    fields,
    clearFilters,
    hasFilters,
  } = useAllWalletsTableData(state);

  return (
    <div>
      <AllWalletsFilters fields={fields} clearFunction={hasFilters ? () => clearFilters() : undefined} />
      {error ? (
        <Table
          columns={headers}
          rows={[]}
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryToResetFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
            />
          }
        />
      ) : (
        <Table
          onSort={onSort}
          columns={headers}
          rows={rows}
          hasStickyHeader
          emptyComponent={
            <EmptyState title={t('components.molecules.table.noRecord')} icon="search_v1" size="m" className="p-6" />
          }
          className="bg-primary h-[calc(100vh-310px)] lightScrollBar"
        />
      )}
      <div className={`flex w-full ${onPerPage ? 'justify-between' : 'justify-end'}`}>
        {onPerPage && <ItemsPerPage initialValue={perPage} values={[25, 50, 75, 100]} onChange={onPerPage} />}
        {pagination?.totalPages > 0 && !error && (
          <Pagination
            {...pagination}
            activePage={pagination.currentPage - 1}
            itemCount={pagination.totalPages * perPage}
            itemPerPage={perPage}
            onPageChange={(item) => onPageChange(Number(item.selected) + 1)}
            isFirstButtonVisible
            isLastButtonVisible
            className="flex mt-3"
          />
        )}
      </div>
    </div>
  );
}
